import { Injectable } from '@angular/core';
import { MenuService } from '@tbtk/menu';
import { BehaviorSubject, Subject } from 'rxjs';
import { FolderHierarchy } from 'src/app/models/folder-hierarchy.model';
import { SearchRequestBody } from 'src/app/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private searchText = new Subject<string>();
  searchText$ = this.searchText.asObservable();

  private isSearhDetail = new BehaviorSubject<boolean>(false);
  isSearhDetail$ = this.isSearhDetail.asObservable();

  private selectedFolder = new Subject<FolderHierarchy>();
  selectedFolder$ = this.selectedFolder.asObservable();

  private searchCriteria = new Subject<SearchRequestBody>();
  searchCriteria$ = this.searchCriteria.asObservable();

  private isDetailSearching = new BehaviorSubject<boolean>(false);
  isDetailSearching$ = this.isDetailSearching.asObservable();

  private resetSearchForm = new Subject<void>();
  resetSearchForm$ = this.resetSearchForm.asObservable();

  private isDetailSearchVisible = new BehaviorSubject<boolean>(false);
  isDetailSearchVisible$ = this.isDetailSearchVisible.asObservable();

  constructor(private menuService: MenuService) {}

  setSearchText(value: string): void {
    this.searchText.next(value);
  }

  setIsSearchDetail(value: boolean): void {
    this.isSearhDetail.next(value);
  }

  setFolder(value: FolderHierarchy): void {
    this.selectedFolder.next(value);
  }

  setSearchCriteria(value: SearchRequestBody): void {
    this.searchCriteria.next(value);
  }

  setIsDetailSearching(value: boolean): void {
    this.isDetailSearching.next(value);
  }

  setResetSearchForm(): void {
    this.resetSearchForm.next();
  }

  setDetailSearchVisibility(value?: boolean): void {
    if (value === undefined) {
      const showing = this.menuService.menuItems.filter((item) => item.component.showing);
      showing.forEach((item) => {
        item.component.close();
      });
      this.isDetailSearchVisible.next(!this.isDetailSearchVisible.value);
    } else {
      this.isDetailSearchVisible.next(value);
    }
  }
}
